import * as React from 'react';
import { useState } from 'react';

/** Material UI Packages. */
import { Box, Snackbar, Alert, Button } from '@mui/material';

/** ReactRedux Packages. */
import { useDispatch, useSelector } from 'react-redux';

/** Internal Components. */
import { closeSnackbar } from 'shared/store/slices/snackBarSlice';

export default function CustomSnackbar() {
    /** Load redux state to select the snackbar. */
    const snackBar = useSelector((state) => state.snackBar);
    /** Dispatch a function to update an edited trade partner. */
    const dispatch = useDispatch();

    /** State for snackbar position. */
    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    /** Destructure the state. */
    const { vertical, horizontal, open } = state;

    /** Handle to close the snackbar. */
    const handleAlertClose = (event, reason) => {
        // Do nothing if the click is outside the snackbar.
        if (reason === 'clickaway') {
            return;
        }

        dispatch(closeSnackbar());
    };

    return (
        <Snackbar
            open={snackBar.open}
            autoHideDuration={snackBar.autoHideDuration ?? 2000}
            onClose={handleAlertClose}
            anchorOrigin={{ vertical, horizontal }}
            key={`${vertical}${horizontal}-${snackBar.seq}`}
        >
            <Alert
                onClose={handleAlertClose}
                severity={snackBar.severity}
                sx={{ width: '100%', whiteSpace: 'pre-line' }}
            >
                {snackBar.message}
            </Alert>
        </Snackbar>
    );
}

/** Top-center column of reminder alerts (avoids overlapping Snackbars when several are due). */
export function ReminderSnackbar({ reminders, onDismiss }) {
    if (!reminders?.length) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 24,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: (theme) => theme.zIndex.snackbar,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                gap: 1,
                width: '100%',
                maxWidth: 500,
                px: 2,
                boxSizing: 'border-box',
                pointerEvents: 'none',
                '& > *': {
                    pointerEvents: 'auto',
                },
            }}
        >
            {reminders.map((reminder) => (
                <Alert
                    key={reminder.id}
                    severity="success"
                    variant="filled"
                    sx={{ display: 'flex', alignItems: 'center' }}
                    action={
                        <Button color="inherit" size="small" onClick={() => onDismiss(reminder.id)}>
                            OK
                        </Button>
                    }
                >
                    {`${reminder.title}: ${reminder.description}`}
                </Alert>
            ))}
        </Box>
    );
}
